import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }


  signup(data) {
    var url = devUrl + "/user/register"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Signup User', url)));
  }

  login(data) {
    var url = devUrl + "/user/login"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Login User', url)));
  }

  forgetpassword(data) {
    var url = devUrl + "/user/forgotpassword"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Forget Password', url)));
  }

  resetpassword(data) {
    var url = devUrl + "/user/changepassword"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Reset Password', url)));
  }


  isloggedin(userid){
    var url = devUrl + '/user/isloggedin?usernumber=' + userid
    return this.http.get(url).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('is Logged in', url)))
  }

  logOut(data){
    var url = devUrl + "/user/logout"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('User Logout', url)));
  }

  ontheflytoken (data) {
    var url = devUrl + "/ontheflytoken"
    return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Onthefly token', url)));
  }

 fetchuserdetails(userid){
  var url = devUrl + '/user/fetchdetails?usernumber=' + userid
  return this.http.get(url).pipe(
    map(response => { return response; })
    , catchError(GlobalService.handleError('is Logged in', url)))
}

  checkpasswordlinkvalidity(data){
    var url = devUrl + '/user/isresetlinkvalid';
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Reset Password Link Validity', url)));
  }


updateuserDetails(data){
  var url = devUrl + "/user/updatedetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('updateuserDetails', url)));
}

changeuserPassword(data){
  var url = devUrl + "/user/changepasswordafterlogin"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('changeuserPassword', url)));
}

resendVerificationEmail(data){
  var url = devUrl + "/user/resendverifyemail"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('resendVerificationEmail', url)));
}

  federatedLinkedInLogin(data) {
    var url = devUrl + "/federatedlinkedinlogin"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Federated LinkedIn Login: ', url)));
  }

  
  getTagUsers(data, fetchAll: boolean = false){
    let url = devUrl + "/typeahead/tagUsers?user=%"+data+"%";
    fetchAll && (url += '&all=true');
      return this.http.get(url).pipe(
        map(response=> {return response}),
        catchError(GlobalService.handleError('Failed gettin user',url))
      )
  }

  sendMentionedEmail(data){
    const url = devUrl + "/user/sendMentionEmail"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Federated LinkedIn Login: ', url)));

  }

  getGeoIpLocationOfUser(updateLocation = false) {
    const url = devUrl + `/user/ip-location${updateLocation ? '?updateLocation=true' : ''}`;
    return this.http.get(url).pipe(
      map(response => { return response; }),
      catchError(GlobalService.handleError('Failed to get user location', url))
    )
  }

}

